import { useState, useEffect } from 'react';
import { ArrowLeft, ArrowRight, Download, ShieldCheck, Lock, Play, ChevronDown, Upload } from 'lucide-react';
import { useDiagnosticContext } from '../../../context/DiagnosticContext';
import '../DiagnosticPremium.css';

export function DownloadRun() {
  const { setCurrentStep, setScannerDownloaded, scannerDownloaded } = useDiagnosticContext();
  const [showSmartScreen, setShowSmartScreen] = useState(false);





  return (
    <div className="stepContainer fade-up">
      {/* COMPONENT 1: AI BRANDING HEADER */}
      <div className="aiBranding">
        <div className="pulseDot"></div>
        <span className="aiBrandingText">AI-Powered System Diagnostics</span>
        <div className="pulseDot"></div>
      </div>

      {/* COMPONENT 2: SCANNER DOWNLOAD CARD */}
      <div className="premiumCardWrapper">
        <div className="premiumCardGlow"></div>
        <div className="premiumCardInner">
          <div className="iconBox">
            <Download size={28} color="var(--accent)" />
          </div>
          <h2 style={{ fontSize: '24px', fontWeight: 800, marginBottom: '12px', color: '#eaeaf0' }}>Download PCCheckr Scanner</h2>
          <p style={{ color: '#9999a8', fontSize: '15px', maxWidth: '480px', margin: '0 auto 32px', lineHeight: '1.6' }}>
            A lightweight, read-only diagnostic utility. No installation required. Safely collects system telemetry for AI analysis.
          </p>

          <a
            href="/downloads/PCCheckr-Scanner.bat"
            download="PCCheckr-Scanner-v2.3.bat"
            className="btnPrimary"
            style={{ padding: '16px 40px', fontSize: '16px' }}
          >
            <Download size={20} /> Download Scanner (.bat)
          </a>

          <div className="trustPills">
            <div className="pill"><span className="pillCheck">✓</span> Read-Only</div>
            <div className="pill"><span className="pillCheck">✓</span> No Personal Files</div>
            <div className="pill"><span className="pillCheck">✓</span> No Installation</div>
            <div className="pill"><span className="pillCheck">✓</span> Safe Commands</div>
          </div>
        </div>
      </div>

      {/* COMPONENT 3: THREE-STEP VISUAL GUIDE */}
      <div className="stepGuide">
        <div className="stepGuideCard">
          <div className="stepBadge">1</div>
          <Download size={24} className="stepIcon" />
          <h3 className="stepTitle">Download</h3>
          <p className="stepDesc">Get the scanner file to your PC</p>
        </div>
        <div className="stepGuideCard">
          <div className="stepBadge">2</div>
          <Play size={24} className="stepIcon" />
          <h3 className="stepTitle">Run Scanner</h3>
          <p className="stepDesc">Right-click & Run as administrator</p>
        </div>
        <div className="stepGuideCard">
          <div className="stepBadge">3</div>
          <Upload size={24} className="stepIcon" />
          <h3 className="stepTitle">Upload .pcc</h3>
          <p className="stepDesc">Upload the results for AI analysis</p>
        </div>
      </div>

      {/* COMPONENT 4: SMARTSCREEN GUIDE (IMPROVED) */}
      <div className="smartScreenWrapper" style={{ border: showSmartScreen ? '1px solid rgba(0, 200, 230, 0.2)' : '1px solid rgba(255, 255, 255, 0.06)' }}>
        <button 
          className="smartScreenToggle" 
          onClick={() => setShowSmartScreen(!showSmartScreen)}
          style={{ padding: '16px 20px' }}
        >
          <ShieldCheck size={18} color={showSmartScreen ? 'var(--accent)' : '#666677'} />
          <span style={{ fontWeight: 600, color: showSmartScreen ? '#eaeaf0' : '#9999a8' }}>Windows shows a warning? Click here for the fix</span>
          <ChevronDown 
            size={16} 
            className="smartScreenChevron" 
            style={{ transform: showSmartScreen ? 'rotate(180deg)' : 'rotate(0deg)' }}
          />
        </button>
        {showSmartScreen && (
          <div className="smartScreenContent" style={{ animation: 'fadeIn 0.3s ease-out' }}>
            <p style={{ fontSize: '14px', color: '#9999a8', marginBottom: '20px' }}>
              Windows SmartScreen warns about new files. This is normal. PCCheckr is safe and transparent.
            </p>
            <div className="smartScreenActions">
              <div className="smartScreenStep">
                <div className="stepCircle">1</div>
                <span>Click <strong>"More info"</strong></span>
              </div>
              <div className="smartScreenStep">
                <div className="stepCircle">2</div>
                <span>Click <strong>"Run anyway"</strong></span>
              </div>
            </div>
            <div style={{ marginTop: '16px', padding: '12px', background: 'rgba(255,255,255,0.02)', borderRadius: '8px', fontSize: '12px', color: '#666677', border: '1px solid rgba(255,255,255,0.04)' }}>
              <strong>Transparency:</strong> You can right-click the .bat file and select "Edit" to see every command it runs. It's 100% human-readable.
            </div>
          </div>
        )}
      </div>

      {/* COMPONENT 5: CONTINUE / BACK ROW */}
      <div className="bottomActions">
        <button className="btnSecondary" onClick={() => setCurrentStep('method')}>
          <ArrowLeft size={14} /> Back
        </button>
        
        <div className="continueWrapper">
          <button 
            className="btnContinue" 
            onClick={() => setCurrentStep('upload')}
          >
            Continue to Upload Results <ArrowRight size={16} />
          </button>
          <div className="continueSubtext">
            After the scanner creates your .pcc file, upload it on the next step.
          </div>
        </div>
      </div>
    </div>
  );
}
